import { autocomplete, KpkApiSearchAutocompleteResult } from "@keepeek/api-client";
import { KpkAutoComplete, KpkAutoCompleteType } from "@keepeek/commons";
import { AxiosInstance } from "axios";

import logger from "../../lib/logger-utils";

export type GetAutocompleteParams = {
  query: string;
  folderIds?: Array<number>;
  fieldIds?: Array<number>;
  limit?: number;
};

export async function getAutocomplete(
  axiosInstance: AxiosInstance,
  params: GetAutocompleteParams,
): Promise<KpkAutoComplete[]> {
  try {
    const result = await autocomplete(axiosInstance, {
      q: params.query,
      limit: params.limit,
      field: params.fieldIds,
      folder: params.folderIds,
    });
    return convertToKpkAutoComplete(result.data);
  } catch (err) {
    logger.error(err);
    logger.error(`Can't autocomplete query ${params.query}`);
  }
  return [];
}

/**
 * Convert to KpkAutoComplete
 * @param kpkApiSearchAutocompleteResult auto complete result
 */
export const convertToKpkAutoComplete = (
  kpkApiSearchAutocompleteResult: KpkApiSearchAutocompleteResult,
): KpkAutoComplete[] => {
  const result: KpkAutoComplete[] = [];
  if (kpkApiSearchAutocompleteResult) {
    kpkApiSearchAutocompleteResult._embedded?.["media-search"]?.forEach((mediaSearch) => {
      if (mediaSearch.q) {
        result.push({
          id: mediaSearch.q,
          label: mediaSearch.q,
          type: KpkAutoCompleteType.Text,
        });
      }
    });
    kpkApiSearchAutocompleteResult._embedded?.folder?.forEach((folder) => {
      if (folder && folder.id && folder.title) {
        result.push({
          id: folder.id.toString(),
          label: folder.title,
          type: KpkAutoCompleteType.Folder,
        });
      }
    });
  }
  return result;
};
